import MiniHeroSection from "../components/services_details/MiniHeroSection";
import ContentBelowHeroBanner from "../components/ContentBelowHeroBanner";
import ServicesPagePostSection from "../components/ServicesPagePostSection";
import PopupSection from "../components/PopupSection";
import { Helmet } from "react-helmet-async";
import useSWR from "swr";
import { useState, useEffect } from "react";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";
import ProductsAndServices from "../components/services/ProductAndServices";
import BuildWith from "../components/services/BuiltWith";
import { useParams, useNavigate } from "react-router-dom";
import WelcomeSection from "../components/services_details/WelcomeSection";
import OverviewSection from "../components/services_details/OverviewSection";
import CapabilitiesSection from "../components/services_details/CapabilitiesSection";
import IndustriesSection from "../components/services_details/IndustriesSection";
import WhySection from "../components/services_details/WhySection";

function ServiceDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  // 1. Saare Hooks top par define karein
  const {
    data: ServicesData,
    isLoading: servicesLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/1256`,
    secureFetcher,
  );

  const {
    data: PostData,
    error: postError,
    isLoading: postLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_SERVICES_DETAIL_ENDPOINT}/${id}`,
    secureFetcher,
  );

  // 2. Redirect logic (Hook) ko Loader se upar rakhein
  useEffect(() => {
    const isWpError =
      PostData?.data?.status === 404 ||
      PostData?.code === "rest_post_invalid_id" ||
      PostData?.code === "rest_no_route";

    if (postError || isWpError) {
      navigate("/404", { replace: true });
    }
  }, [postError, PostData, navigate]);

  // 3. AB LOADER KA RETURN LAGAYEIN (Saare Hooks chalne ke baad)
  if (servicesLoading || postLoading) {
    return (
      <div className="text-center p-5 mt-5" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div
          className="spinner-border"
          style={{ color: "#3db4e5", width: '3rem', height: '3rem' }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const welcomSectionData = {
    banner_image: ServicesData?.acf?.hero_banner?.banner_image,
    banner_main_heading: PostData?.acf?.welcome_section?.title,
    hero_image: PostData?.acf?.welcome_section?.hero_image,
  };

  return (
    <>
      {ServicesData && (
        <Helmet>
          <title>{ServicesData?.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={ServicesData?.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={ServicesData?.yoast_head_json?.og_description}
          />
        </Helmet>
      )}

      <MiniHeroSection data={welcomSectionData} />

      {PostData && (
        <>
          {PostData?.acf?.overview_section?.overview_content && (
            <OverviewSection data={PostData?.acf} />
          )}

          {PostData?.acf?.capabilities?.capabilities_feature && (
            <CapabilitiesSection data={PostData?.acf} />
          )}

          {PostData?.acf?.welcome_section?.content_below_heading && (
            <WelcomeSection data={PostData?.acf} />
          )}

          {PostData?.acf?.industries?.industries_list && (
            <IndustriesSection data={PostData?.acf} />
          )}

          {PostData?.acf?.why_section?.why_points && (
            <WhySection data={PostData?.acf} />
          )}

          <BuildWith content={PostData?.acf?.build_with} />
        </>
      )}
    </>
  );
}

export default ServiceDetails;